export default class BookingCalendar {
    constructor() {
        this.bookingWidget = document.getElementById('bookingWidget');
        this.bookingButton = document.getElementById('bookingButton');
        if (!this.bookingWidget) {
            return
        }

        this.bookingData = {
            ApiUrl: `https://booking.nfhotel.pl/api2/${this.bookingButton.dataset.settingsId}`,
            standardId: this.bookingButton.dataset.room_standards,
            widgetId: this.bookingButton.dataset.settingsId,
            dataStart: this.bookingButton.dataset.date_from,
            dataEnd: this.bookingButton.dataset.date_to,
            adultCount: this.bookingButton.dataset.adult_count,
            maxGuests: null,
            displayedPrice: null,
            price: null,
            crossedPrice: null,
        }

        this.DOMelements = {
            calendarOpen: this.bookingWidget.querySelector('.calendar-open'),
            calendarStartDate: this.bookingWidget.querySelector('.calendar-start-date'),
            calendarEndDate: this.bookingWidget.querySelector('.calendar-end-date'),
            guestDecrease: this.bookingWidget.querySelector('.guest-decrease'),
            guestIncrease: this.bookingWidget.querySelector('.guest-increase'),
            guestsCount: this.bookingWidget.querySelector('.guests-count'),
            priceElement: this.bookingWidget.querySelector('.price'),
            crossedPriceElement: this.bookingWidget.querySelector('.crossed-price'),
        }

        this.cache = {
            roomsDescription: null,
            roomsDescriptionTimestamp: null,
            priceCache: new Map(),
            cacheExpirationTime: 30 * 60 * 1000
        };

        this.priceRequestTimeout = null;
        this.lastPriceRequestParams = null;

        this.cal = null;
        this.currentDate = new Date();

        this.init();
        this.events()
    }

    init() {
        if (!window.nfHotelBooking ||
            !window.nfHotelBooking.setupCalendar ||
            typeof window.nfHotelBooking.setupCalendar !== 'function') {
            return;
        }

        this.getMaximumGuests();
        this.loadPriceCacheFromSessionStorage();

        this.locale = {
            en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            de: ['Jan', 'Feb', 'Mär', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
            pl: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
            cs: ['Led', 'Ún', 'Břez', 'Dub', 'Květ', 'Červ', 'Červen', 'Srp', 'Září', 'Říj', 'List', 'Pros'],
        };

        this.cal = window.nfHotelBooking.setupCalendar({
            style: {
                color: '#d7a97d',
                textColor: '#fff',
                zIndex: 11,
                font: 'Lato'
            },
            onDateSelect: (dates) => this.updateDates(dates),
            rangeSelection: true,
            locale: 'pl',
            forPets: false,
            attached: true,
            key: 'apartament',
            minDate: this.currentDate,
            maxDate: new Date(this.currentDate.getFullYear() + 3, this.currentDate.getMonth(), this.currentDate.getDate()),
            nfhotel: {
                standardId: this.bookingData.standardId,
                instanceId: this.bookingData.widgetId
            }
        })
    }

    async getMaximumGuests() {
        try {
            const cacheKey = `rooms_description_${this.bookingData.widgetId}`;

            if (this.isCacheValid()) {
                this.processRoomsDescription(this.cache.roomsDescription);
                return;
            }

            const cachedSessionData = sessionStorage.getItem(cacheKey);
            const cachedSessionTimestamp = sessionStorage.getItem(`${cacheKey}_timestamp`);

            if (cachedSessionData && cachedSessionTimestamp) {
                const timestamp = parseInt(cachedSessionTimestamp);
                const now = Date.now();

                if (now - timestamp < this.cache.cacheExpirationTime) {
                    const data = JSON.parse(cachedSessionData);

                    this.cache.roomsDescription = data;
                    this.cache.roomsDescriptionTimestamp = timestamp;

                    this.processRoomsDescription(data);
                    return;
                }
            }

            const response = await fetch(`${this.bookingData.ApiUrl}/rooms_description`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();

            this.cacheRoomsDescription(data);

            sessionStorage.setItem(cacheKey, JSON.stringify(data));
            sessionStorage.setItem(`${cacheKey}_timestamp`, Date.now().toString());

            this.processRoomsDescription(data);

        } catch (error) {
            console.log('Error fetching rooms description:', error);
        }
    }

    isCacheValid() {
        if (!this.cache.roomsDescription || !this.cache.roomsDescriptionTimestamp) {
            return false;
        }

        const now = Date.now();
        const timeDiff = now - this.cache.roomsDescriptionTimestamp;

        return timeDiff < this.cache.cacheExpirationTime;
    }

    cacheRoomsDescription(data) {
        this.cache.roomsDescription = data;
        this.cache.roomsDescriptionTimestamp = Date.now();
    }

    processRoomsDescription(data) {
        const selectedRoom = data.find(room => room.roomstandard_id === this.bookingData.standardId);

        if (selectedRoom) {
            const maxGuestsEquipment = selectedRoom.equipment.find(item => item.id === "28");
            this.bookingData.maxGuests = maxGuestsEquipment ? parseInt(maxGuestsEquipment.value) : 6;

            this.DOMelements.guestsCount.textContent = this.bookingData.adultCount;
        } else {
            this.bookingData.maxGuests = 6;
        }
    }

    createPriceCacheKey(search) {
        return `${search.date_from}-${search.date_to}-${search.adult_count}-${search.room_standards.join(',')}`;
    }

    isPriceCacheValid(cacheEntry) {
        const now = Date.now();
        const cacheAge = now - cacheEntry.timestamp;
        const priceExpirationTime = 10 * 60 * 1000;

        return cacheAge < priceExpirationTime;
    }

    getCachedPrice(cacheKey) {
        if (this.cache.priceCache.has(cacheKey)) {
            const cacheEntry = this.cache.priceCache.get(cacheKey);
            if (this.isPriceCacheValid(cacheEntry)) {
                return cacheEntry.data;
            } else {
                this.cache.priceCache.delete(cacheKey);
            }
        }

        const sessionKey = `price_${this.bookingData.widgetId}_${cacheKey}`;
        const cachedData = sessionStorage.getItem(sessionKey);
        const cachedTimestamp = sessionStorage.getItem(`${sessionKey}_timestamp`);

        if (cachedData && cachedTimestamp) {
            const timestamp = parseInt(cachedTimestamp);
            const cacheEntry = {data: JSON.parse(cachedData), timestamp};

            if (this.isPriceCacheValid(cacheEntry)) {
                this.cache.priceCache.set(cacheKey, cacheEntry);
                return cacheEntry.data;
            } else {
                sessionStorage.removeItem(sessionKey);
                sessionStorage.removeItem(`${sessionKey}_timestamp`);
            }
        }

        return null;
    }

    cachePriceData(cacheKey, data) {
        const cacheEntry = {
            data: data,
            timestamp: Date.now()
        };

        this.cache.priceCache.set(cacheKey, cacheEntry);

        const sessionKey = `price_${this.bookingData.widgetId}_${cacheKey}`;
        sessionStorage.setItem(sessionKey, JSON.stringify(data));
        sessionStorage.setItem(`${sessionKey}_timestamp`, cacheEntry.timestamp.toString());
    }

    loadPriceCacheFromSessionStorage() {
        const prefix = `price_${this.bookingData.widgetId}_`;

        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (key && key.startsWith(prefix) && !key.endsWith('_timestamp')) {
                const cacheKey = key.substring(prefix.length);
                const timestampKey = `${key}_timestamp`;
                const timestamp = sessionStorage.getItem(timestampKey);

                if (timestamp) {
                    const cacheEntry = {
                        data: JSON.parse(sessionStorage.getItem(key)),
                        timestamp: parseInt(timestamp)
                    };

                    if (this.isPriceCacheValid(cacheEntry)) {
                        this.cache.priceCache.set(cacheKey, cacheEntry);
                    }
                }
            }
        }
    }

    async loadLowestPrice() {
        return new Promise((resolve) => {
            if (this.priceRequestTimeout) {
                clearTimeout(this.priceRequestTimeout);
            }

            this.priceRequestTimeout = setTimeout(async () => {
                await this.performPriceRequest();
                resolve();
            }, 300);
        });
    }

    async performPriceRequest() {
        try {
            const search = {
                "date_from": this.bookingData.dataStart,
                "date_to": this.bookingData.dataEnd,
                "adult_count": this.bookingData.adultCount,
                "room_standards": [this.bookingData.standardId],
            };

            const searchString = JSON.stringify(search);

            if (this.lastPriceRequestParams === searchString) {
                return;
            }

            this.lastPriceRequestParams = searchString;

            const cacheKey = this.createPriceCacheKey(search);

            const cachedData = this.getCachedPrice(cacheKey);
            if (cachedData) {
                this.updatePriceData(cachedData);
                return;
            }

            const response = await fetch(`${this.bookingData.ApiUrl}/standard_lowest_price`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(search)
            });

            const responseText = await response.text();
            if (!response.ok) return;

            const result = JSON.parse(responseText);

            this.cachePriceData(cacheKey, result);

            this.updatePriceData(result);

        } catch (error) {
            console.log('Error fetching price data:', error);
        }
    }

    updatePriceData(result) {
        const priceData = result.lowest_prices?.[this.bookingData.standardId];

        if (priceData?.displayed_price != null) {
            this.bookingData.displayedPrice = priceData.displayed_price;
        }

        if (priceData?.crossed_price != null) {
            this.bookingData.crossedPrice = priceData.crossed_price;
        }
    }

    clearRoomsDescriptionCache() {
        this.cache.roomsDescription = null;
        this.cache.roomsDescriptionTimestamp = null;

        const cacheKey = `rooms_description_${this.bookingData.widgetId}`;
        sessionStorage.removeItem(cacheKey);
        sessionStorage.removeItem(`${cacheKey}_timestamp`);
    }

    clearPriceCache() {
        this.cache.priceCache.clear();

        const prefix = `price_${this.bookingData.widgetId}_`;
        const keysToRemove = [];

        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (key && key.startsWith(prefix)) {
                keysToRemove.push(key);
            }
        }

        keysToRemove.forEach(key => sessionStorage.removeItem(key));
    }

    clearAllCache() {
        this.clearRoomsDescriptionCache();
        this.clearPriceCache();
    }

    cleanupExpiredCache() {
        for (const [key, entry] of this.cache.priceCache.entries()) {
            if (!this.isPriceCacheValid(entry)) {
                this.cache.priceCache.delete(key);
            }
        }

        const prefix = `price_${this.bookingData.widgetId}_`;
        const keysToRemove = [];

        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (key && key.startsWith(prefix) && !key.endsWith('_timestamp')) {
                const timestampKey = `${key}_timestamp`;
                const timestamp = sessionStorage.getItem(timestampKey);

                if (timestamp) {
                    const cacheEntry = {timestamp: parseInt(timestamp)};
                    if (!this.isPriceCacheValid(cacheEntry)) {
                        keysToRemove.push(key);
                        keysToRemove.push(timestampKey);
                    }
                }
            }
        }

        keysToRemove.forEach(key => sessionStorage.removeItem(key));
    }

    updateDates(dates) {
        if (!dates) {
            dates = []
            dates[0] = this.currentDate,
                dates[1] = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() + 1)

            this.cal.setDates(dates[0].getTime(), dates[1].getTime())
        }

        const start = dates[0]
        const end = dates[1]

        document
            .querySelectorAll('.nf-date-from-picker .nf-date-month')
            .forEach(el => el.textContent = this.locale['pl'] ? this.locale['pl'][start.getMonth()] : this.locale['en'][start.getMonth()])
        document
            .querySelectorAll('.nf-date-from-picker .nf-date-day')
            .forEach(el => el.textContent = ('0' + start.getDate()).slice(-2))

        document
            .querySelectorAll('.nf-date-to-picker .nf-date-month')
            .forEach(el => el.textContent = this.locale['pl'] ? this.locale['pl'][end.getMonth()] : this.locale['en'][end.getMonth()])
        document
            .querySelectorAll('.nf-date-to-picker .nf-date-day')
            .forEach(el => el.textContent = ('0' + end.getDate()).slice(-2))

        this.bookingData.dataStart = this.formatDate(start);
        this.bookingData.dataEnd = this.formatDate(end);

        document.querySelectorAll('.nf-button').forEach(btn => {
            btn.setAttribute('data-date_from', this.bookingData.dataStart)
            btn.setAttribute('data-date_to', this.bookingData.dataEnd)
        })

        this.DOMelements.calendarStartDate.textContent = this.formatDateForHumans(start)
        this.DOMelements.calendarEndDate.textContent = this.formatDateForHumans(end)
        this.loadLowestPrice().then(r => this.updatePrices());
    }

    formatDate(date) {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    }

    formatDateForHumans(date) {
        const day = date.getDate();
        const monthNames = this.locale['pl'] || this.locale['en'];
        const month = monthNames[date.getMonth()];

        return `${day} ${month}`;
    }

    updatePrices() {
        this.updatePriceElement(this.DOMelements.priceElement, this.bookingData.displayedPrice, '<span class="text-lg font-normal">Cena od</span>');
        this.updatePriceElement(this.DOMelements.crossedPriceElement, this.bookingData.crossedPrice);
    }

    updatePriceElement(element, price, priceText = '') {
        if (price != null) {
            element.innerHTML = `${priceText ?? priceText } ${price.toFixed(2).replace('.', ',')} <span class="normal-case">zł</span>`;
            element.classList.remove('hidden');
        } else {
            element.innerHTML = '';
            element.classList.add('hidden');
        }
    }

    updateGuestsCount() {
        this.DOMelements.guestIncrease.addEventListener('click', () => {
            const currentCount = parseInt(this.bookingData.adultCount);
            if (currentCount < this.bookingData.maxGuests) {
                this.bookingData.adultCount = currentCount + 1;
                this.DOMelements.guestsCount.textContent = this.bookingData.adultCount;
                this.loadLowestPrice().then(() => this.updatePrices());
            }
        });

        this.DOMelements.guestDecrease.addEventListener('click', () => {
            const currentCount = parseInt(this.bookingData.adultCount);
            if (currentCount > 1) {
                this.bookingData.adultCount = currentCount - 1;
                this.DOMelements.guestsCount.textContent = this.bookingData.adultCount;
                this.loadLowestPrice().then(() => this.updatePrices());
            }
        });
    }

    events() {
        this.DOMelements.calendarOpen.addEventListener('click', () => {
            this.cal.openCalendar();
        })
        this.updateGuestsCount();

        setInterval(() => {
            this.cleanupExpiredCache();
        }, 5 * 60 * 1000);
    }
}